module.exports = __webpack_public_path__ + "static/media/icon-cloud.1fc43175.svg";